import { jsx as o } from "react/jsx-runtime";
const e = ({
  width: t,
  height: L,
  className: r
}) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    fill: "none",
    height: L,
    viewBox: "0 0 30 27",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M22.9662 26L14.9499 22.0857L6.90012 25.9323L8.26183 17.3334L2 11.1003L10.8587 9.69907L15.041 2L19.1514 9.73342L28 11.2053L21.6815 17.3874L22.9662 26Z",
        stroke: "currentColor"
      }
    )
  }
);
export {
  e as Content
};
